import { logPageView, pushToDataLayer } from "analytics";
import React, { useEffect } from "react";
import { MainRouter } from "router";
import ReactGA from "react-ga";
import { useScrollDepth } from "hooks";

const App = () => {
	useScrollDepth();
	const gaEnv = process.env.REACT_APP_GA_TRACKING_ID;

	useEffect(() => {
		if (gaEnv) {
			ReactGA.initialize(gaEnv);
		}
	}, [gaEnv]);

	useEffect(() => {
		if (gaEnv) {
			logPageView();
		}

		pushToDataLayer("page_view", {
			page_path: window.location.pathname,
			page_title: document.title,
		});
	}, [gaEnv]);

	return <MainRouter />;
};

export default App;
